import React, { useEffect, useCallback, useContext } from "react";
import { MapkitProvider, useMap } from "react-mapkit";
import { Box } from "rebass/styled-components";
import theme from "../../lib/theme";
import { LocaleContext } from "../../components/locale";
import { getMapkitToken } from "../../components/search/SearchMap";

interface Props {
  width: string;
  paddingTop: string;
  position: string;
  lat: string;
  lng: string;
}

const Map = (props: Props) => {
  const { width, paddingTop, lat, lng } = props;
  const {
    map,
    mapProps: { mapRef, mapkit }
    // @ts-ignore (There is an error on mapkit-typescript types)
  } = useMap({ showsCompass: "hidden" });

  const fitMapToOverlay = useCallback(() => {
    if (!map) {
      return;
    }
    map.showItems(map.overlays, {
      animate: false,
      padding: new mapkit.Padding(50, 50, 50, 50)
    });
  }, [map, mapkit]);

  useEffect(() => {
    if (!map || !mapkit) {
      return;
    }

    const coordinates = new mapkit.Coordinate(parseFloat(lat), parseFloat(lng));
    const overlay = new mapkit.CircleOverlay(coordinates, 100, {
      style: new mapkit.Style({
        lineWidth: 4,
        strokeColor: theme.colors.springGreen,
        fillColor: theme.colors.springGreen,
        fillOpacity: 0.3
      })
    });

    map.addOverlay(overlay);

    // Center the map on this overlay
    fitMapToOverlay();
  }, [mapkit, map, lat, lng, fitMapToOverlay]);

  return (
    <Box
      ref={mapRef}
      sx={{
        width: width,
        paddingTop: paddingTop,
        position: "relative",
        "> *": {
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }}
    />
  );
};

Map.defaultProps = {
  width: "100%",
  paddingTop: "70%"
};

const MapWithMapkitProvider = props => {
  const { country } = useContext(LocaleContext);

  return (
    <MapkitProvider tokenOrCallback={getMapkitToken(country) || ""}>
      <Map {...props} />
    </MapkitProvider>
  );
};

export default MapWithMapkitProvider;
